import { RiskBadge, type Risk } from "./risk-badge.tsx";

export interface DiffItem {
  readonly key: string;
  readonly risk: Risk;
  /** Câu mô tả thao tác đã qua i18n (vd « Thêm trường “Lương” vào “Ứng viên” »). */
  readonly text: string;
  /** « 3 bản ghi » — null khi thao tác không chạm bản ghi. */
  readonly records: string | null;
}

/** Danh sách thao tác theo id + mức rủi ro + số bản ghi thật (PATTERNS mẫu 1). */
export function DiffPreview({ items, riskLabel, emptyLabel, title }: { items: readonly DiffItem[]; riskLabel: (r: Risk) => string; emptyLabel: string; title: string }) {
  if (items.length === 0) return <p className="text-sm text-(--saa-fg-muted)">{emptyLabel}</p>;
  return (
    <section aria-label={title}>
      <ul className="divide-y divide-(--saa-border) rounded-md border border-(--saa-border)">
        {items.map((d) => (
          <li key={d.key} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 text-sm">
            <span>{d.text}</span>
            <span className="flex items-center gap-2">
              {d.records ? <span className="text-xs text-(--saa-fg-muted)">{d.records}</span> : null}
              <RiskBadge risk={d.risk} label={riskLabel(d.risk)} />
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
